<div class="header">
    <div class="title-container">Delete Group</div>
    <div class="close-btn" (click)="cancel()"></div>
</div>
<div class="content-container">
    <p>Do you want to delete group “{{groupName}}” with all options? All options will be gone.</p>
</div>
<div class="btns-container">
    <button class="btn cancel-btn" (click)="cancel()">Cancel</button>
    <button class="btn delete-btn" (click)="deleteGroup()">Delete</button>
</div>
